// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2VT7W","title":"Images45_title__1sbxG","images":"Images45_images__3g4zy"};